import { darken, lighten } from '@mui/system';
import React from 'react';
import { Grid, IconButton, Toolbar, Typography } from 'src/components';
import Card from 'src/components/Card';
import CardContent from 'src/components/CardContent';
import CardHeader from 'src/components/CardHeader';
import BaseComponent from 'src/core/base.component';
import VwGnlMesajDTO from 'src/models/Mesaj/VwGnlMesajDTO';
import { useLazyMesajOkunduQuery, useLazyMesajPersonelOkumaBilgiQuery, useMesajPersonelListesiQuery } from 'src/services/Mesaj/MesajApi';
import { useAppDispatch, useAppSelector } from 'src/store';
import { MesajSlice } from 'src/store/Slices/Mesaj/MesajSlice';
import { helper } from 'src/utils/helper';
import MesajEkle from './MesajEkle';
import api from 'src/services/core/api';

interface IMesajListeProps { };
/**
 * Hasta müracaat bazlı mesajı önizleyen component
 * @param props 
 * @returns 
*/
const MesajListe = (props: IMesajListeProps): JSX.Element => {
    const state = useAppSelector(s => s.mesaj);
    const userInfo = useAppSelector(s => s.userLogin.userInfo);
    const organizasyon = useAppSelector(s => s.userOrganizasyon.organizasyon);
    const dispatch = useAppDispatch();
    const readOnly = (state.activeRow?.ekleyenKullanici !== userInfo?.id);

    const query = useMesajPersonelListesiQuery({ muracaatId: state.muracaatId }, { skip: state?.muracaatId > 0 ? false : true });
    const [oku, okuState] = useLazyMesajOkunduQuery();
    const [querySayac, querySayacState] = useLazyMesajPersonelOkumaBilgiQuery();

    /**
     * Array içerisinde tıklanan kaydı row da gönderip okunmamışsa okunması için apiye gönderen sonra okuma ekranını açan okunduysa direk okuma ekranını açan fonksiyon
     * @param event 
     * @param row 
    */
    const cardHandler = async (event: React.MouseEvent<HTMLDivElement, MouseEvent>, row: VwGnlMesajDTO) => {
        if (!querySayacState.isFetching) {
            await querySayac({ kullaniciId: userInfo.id, muracaatIds: [row?.muracaatId], organizasyonId: organizasyon.fkOrganizasyon })
                .unwrap()
                .then(async (res) => {
                    const okunacakMi = querySayacState.data?.find((f) => f.muracaatId === row?.muracaatId);
                    if (okunacakMi?.okumaBilgisi > 0) {
                        if (!okuState.isFetching) {
                            await oku({ mesajId: row?.id }).unwrap().then(() => {
                                dispatch(api.util.invalidateTags(["MesajOkumaBilgi", "MesajModulOkumaBilgi", "MesajModulListesi", "MesajListesi"]));
                                dispatch(MesajSlice.actions.setActiveRow(row));
                                dispatch(MesajSlice.actions.setEditMode(true));
                            }).catch(e => e);
                        }
                        return;
                    }
                    dispatch(MesajSlice.actions.setActiveRow(row));
                    dispatch(MesajSlice.actions.setEditMode(true));
                }).catch(e => e);
        }
    };
    /**
     * Mesaj edit modunu kapatmak için kullanılan fonksiyon
     * @param event 
    */
    const closeHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        dispatch(MesajSlice.actions.setActiveRow(new VwGnlMesajDTO()));
        dispatch(MesajSlice.actions.setEditMode(false));
    };
    return (
        <BaseComponent
            loading={query.isFetching}
        >
            <Grid container>
                {!state.editMode && (
                    <>
                        {(!query.isFetching && query.data?.length > 0) && query.data?.map((m) => {
                            return (
                                <Grid key={m?.id} item xs={12} sm={6} md={4}>
                                    <Card variant="outlined" onClick={(e) => { cardHandler(e, m); }} sx={{ cursor: "pointer" }}>
                                        <CardHeader style={{ padding: 0, margin: 0 }} sx={{ backgroundImage: (theme) => `linear-gradient(to bottom right, ${theme.palette.mode == 'dark' ? darken(theme.palette.primary.main, 0.5) : lighten(theme.palette.primary.main, 0.8)}, ${theme.palette.background.paper})` }}
                                            title={
                                                <Toolbar>
                                                    <Typography sx={{ flexGrow: 1, fontWeight: "400" }}>
                                                        {m?.baslik}
                                                    </Typography>
                                                    <Typography sx={{ flexGrow: 1 }}>
                                                        {helper.dateValueFormat3(m?.eklemeTarihi)}
                                                    </Typography>
                                                    <IconButton customType="edit" />
                                                </Toolbar>
                                            } />
                                        <CardContent style={{ padding: 0, margin: 0 }}>
                                            <div style={{ height: "10vh", overflow: "scroll", fontSize: 12 }}>{m?.icerik}</div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )
                        })}
                        {query.data?.length === 0 && (
                            <>Mesaj yok</>
                        )}
                    </>
                )}
                {state.editMode && (
                    <Grid item>
                        <MesajEkle modulRow={false} initialValues={state.activeRow} readOnly={readOnly} closeHandler={closeHandler} />
                    </Grid>
                )}
            </Grid>
        </BaseComponent>
    );
};

export default MesajListe;